"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Message_1 = __importDefault(require("../../../../misc/Message"));
var CONFIG = {
    normal: {
        iconColor: undefined,
        iconName: undefined,
        color: 'PALE_BLUE_50',
    },
    error: {
        iconColor: undefined,
        iconName: undefined,
        color: 'PINK_20',
    },
};
var Message = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'normal' : _b, children = _a.children;
    return (react_1.default.createElement(Message_1.default, __assign({ "data-component-name": "Form.Message" }, CONFIG[type], { level: "2" }), children));
};
exports.default = Message;
